
/** Chave de acesso da NF-e: 44 dígitos numéricos (padrão SEFAZ). */
const TAMANHO_CHAVE = 44;

/**
 * Extrai a chave de acesso de uma leitura de câmera. O Code128 do DANFE traz os 44 dígitos
 * (às vezes prefixados por "NFe" no QR, ou com espaço/quebra que o leitor injeta). Só devolve
 * a string quando sobra EXATAMENTE 44 dígitos — assim uma leitura de EAN de produto (13
 * dígitos) ou um código truncado não é confundida com uma chave.
 */
export function extrairChaveValida(codigo: string): string | null {
  const digitos = (codigo ?? '').replace(/\D/g, '');
  return digitos.length === TAMANHO_CHAVE ? digitos : null;
}
